/**
 * Функция получения и подстановики параметров в параметризованные ссылки
 * @param links - объект с ссылками с параметрами
 * @param name - ключ ссылки в объекте
 * @param params - объект параметров для подстановки
 * @returns
 */
export const getUrlWithParams = (links: Record<string, string | undefined>, name: string, params?: Record<string, any>) => {
    const link = links[name];
    if (!link) {
        return;
    }

    if (!params) {
        return link;
    }

    return link.replace(/\{(\w*)\}/g, (_, key) => {
        return (key && params[key]) ?? '';
    });
};
